export const GET_LOADS = "GET_LOADS";
export const GET_LOAD_BY_ID = "GET_LOAD_BY_ID";
export const UPDATE_LOAD = "UPDATE_LOAD";
export const DELETE_LOAD = "DELETE_LOAD";
export const CREATE_LOAD = "CREATE_LOAD";
export const UPLOAD_LOAD_FILE = "UPLOAD_LOAD_FILE";
export const GET_LOAD_FILES = "GET_LOAD_FILES";
